import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { assignMod, leaveRoom } from '../../../../actions/userActions';
import AdminRoomMembersView from '../../../../containers/ChatRooms/Room/Admin/Room/AdminRoomMembers';

const AdminRoomMembers = () => {
  const { membersRoom, roomInfo } = useSelector(state => state.userInfo)
  const dispatch = useDispatch()
  const kick = (member) => {
    dispatch(leaveRoom({
      chatRoomID: roomInfo._id,
      entityID: member.entityID
    }))
  }
  const addMod = (member) => {
    dispatch(assignMod({
      chatRoomID: roomInfo._id,
      entityID: member.entityID
    }))
  }
  const removeMod = (member) => {
    dispatch(assignMod({
      chatRoomID: roomInfo._id,
      entityID: null
    }))
  }
  return <AdminRoomMembersView kick={kick} addMod={addMod} removeMod={removeMod} roomInfo={roomInfo} members={membersRoom} />
};

export default AdminRoomMembers;
